import { render, staticRenderFns } from "./SignatureFlow.vue?vue&type=template&id=bd7c72a6&scoped=true"
import script from "./SignatureFlow.vue?vue&type=script&lang=js"
export * from "./SignatureFlow.vue?vue&type=script&lang=js"
import style0 from "./SignatureFlow.vue?vue&type=style&index=0&id=bd7c72a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c72a6",
  null
  
)

export default component.exports